import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/phoneImageMfa.png'
import _imports_1 from '@/assets/img/mfaAuthen.png'
import _imports_2 from '@/assets/img/mfaPasskey.png'


const _withScopeId = n => (_pushScopeId("data-v-73816c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-text-[#231F20] tw-text-[15px] tw-leading-[145%]" }
const _hoisted_2 = { class: "tw-text-[15px] tw-flex md:tw-flex-row tw-flex-col tw-text-[#211F58] tw-font-medium tw-leading-[100%] tw-gap-[26px]" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1
}
const _hoisted_5 = { class: "text-image" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0
}
const _hoisted_7 = {
  key: 1,
  src: _imports_2
}
const _hoisted_8 = { class: "text-image" }

import { ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";


export default /*#__PURE__*/_defineComponent({
  __name: 'mfaSelectionContent',
  props: {
  multipleOptions: {
    type: Boolean,
    required: false,
  },
  fromLogin: {
    type: Boolean,
    required: false,
  },
},
  emits: [
  "update:click:passkey",
  "update:click:authen",
  "close",
],
  setup(__props, { emit }) {

const props = __props;



const multipleOptionsRef = ref(props.multipleOptions);

watch(
  () => props.multipleOptions,
  (value) => {
    multipleOptionsRef.value = value;
  },
);



const handleByPasskey = () => {
  emit("update:click:passkey");
};

const handleByAuthen = async () => {
  emit("update:click:authen");
};

const closeModal = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.fromLogin)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["tw-text-right tw-cursor-pointer tw-pr-[20px] tw-pt-[20px]", `${__props.fromLogin ? 'tw-h-[39px]' : ''}`])
        }, [
          _createElementVNode("img", {
            class: "cross_icon tw-h-[19px] tw-w-[19px]",
            src: "/img/cross-x_icon.svg",
            alt: "cross",
            onClick: closeModal
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["tw-flex tw-flex-col tw-p-5", `${
      __props.fromLogin
        ? 'from-login md:tw-p-[70px] md:tw-pt-[31px]'
        : 'md:tw-p-10 tw-gap-10'
    }`])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-flex tw-flex-col tw-font-[Poppins]", `${__props.fromLogin ? 'tw-gap-[15px] tw-pb-[30px]' : 'tw-gap-[10px]'}`])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["tw-font-semibold tw-leading-[100%]", `${
          __props.fromLogin
            ? 'tw-text-[26px] tw-text-[#0345BD]'
            : 'tw-text-[25px] tw-text-[#211F58]'
        }`])
        }, _toDisplayString(_unref(getComponentUiText)(
            "app-settings-team-members-modal-mfa-selection-title-1",
          )), 3),
        _createElementVNode("div", _hoisted_1, _toDisplayString(multipleOptionsRef.value
            ? _unref(getComponentUiText)(
                "app-settings-team-members-modal-mfa-selection-content-a-1",
              )
            : _unref(getComponentUiText)(
                "app-settings-team-members-modal-mfa-selection-content-b-1",
              )), 1)
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        (multipleOptionsRef.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              "data-cy": "totp-selection-button-setup-authen",
              class: "tw-cursor-pointer tw-justify-center tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] select_option tw-px-[40px] tw-py-[30px] tw-gap-[20px] tw-flex-1",
              onClick: handleByAuthen
            }, [
              (!__props.fromLogin)
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : (_openBlock(), _createElementBlock("img", _hoisted_4)),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-team-members-modal-mfa-selection-button-title-setup-authen-1",
            )), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "tw-cursor-pointer tw-justify-center tw-flex tw-flex-col tw-items-center tw-bg-[#F2F8FF] select_option tw-px-[40px] tw-py-[30px] tw-gap-[20px] tw-flex-1",
          onClick: handleByPasskey
        }, [
          (!__props.fromLogin)
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (_openBlock(), _createElementBlock("img", _hoisted_7)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-team-members-modal-mfa-selection-button-title-setup-passkey-1",
            )), 1)
        ])
      ])
    ], 2)
  ], 64))
}
}

})